(function () {
  
    "use strict";

    Controllers.CapitalController = class CapitalController extends Controllers.BaseControllerES6 {
        // @ngInject
        constructor($scope, $injector, $stateParams) {
            super($scope, $injector);
            

            this.__objectType = 'CapitalController';
            this.source = $stateParams.source;
        }
    };
}());
